// Рядок ідентифікації станції у верхній частині розділу SCADA.
//
// ЄДИНИЙ власник цього блоку — ScadaLayout, який його й рендерить. Сторінки
// його не малюють і не передають: раніше він приходив пропом `above` з
// station/page.tsx, тому існував лише на картці станції та зникав на «Ручному
// керуванні» й решті розділів.
//
// Дані беруться зі спільного контексту, нічого не хардкодиться:
//   · підприємство — контрагент вибраного активу (селектор у топбарі), із
//     запасним варіантом із SCADA-довідника;
//   · EIC — із живої телеметрії станції (реєстр активів), запасний — довідник;
//   · літера типу — з самого коду (utils/eic), не зашита.
import { scada } from '@/scada/tokens';
import { eicType } from '@/utils/eic';

// Одна типографіка на обидві частини: кегль 13, вага 600. Розрізняє їх лише
// колір — назва приглушена, код основний.
const ID_ROW = {
  fontSize: 13,
  fontWeight: 600,
  lineHeight: 1.2,
  letterSpacing: '0.01em',
  fontVariantNumeric: 'tabular-nums',
} as const;

export default function StationIdentity({ company, eic }: { company?: string | null; eic?: string | null }) {
  const code = eic?.trim().toUpperCase() || null;
  const kind = eicType(code);
  if (!company && !code) return null;

  return (
    <div className="flex items-baseline gap-3 min-w-0" style={ID_ROW}>
      {company && (
        <span className="truncate" style={{ color: scada.textDim }}>{company}</span>
      )}
      {code && (
        <span className="whitespace-nowrap shrink-0" style={{ color: scada.text }}>
          {kind && <span style={{ color: scada.textDim, marginRight: 3 }}>{kind}:</span>}
          {code}
        </span>
      )}
    </div>
  );
}
